{
    "World": {
        "center": [
            0,
            20
        ],
        "projection": "WebMercator",
        "zoom": 1.0,
        "max_zoom": 12,
        "radius": 4.5,
        "country_opacity": 0.5,
        "marker_symbol": "circle"
    },
    "Europe": {
        "center": [
            8.5,
            53
        ],
        "projection": "WebMercator",
        "zoom": 3.0,
        "max_zoom": 12,
        "radius": 3.5,
        "country_opacity": 0.5,
        "marker_symbol": "circle"
    },
    "Norway": {
        "center": [
            15.63,
            64.32
        ],
        "zoom": 4.75,
        "max_zoom": 10,
        "radius": 3.5,
        "country_opacity": 0.5,
        "marker_symbol": "circle",
        "padding": 50
    },
    "DOMOS": {
        "center": [
            -55.70894827818417,
            -11.190097150084284
        ],
        "projection": "WebMercator",
        "zoom": 2,
        "max_zoom": 12,
        "radius": 2.5,
        "country_opacity": 0.5,
        "marker_symbol": "circle"
    },
    "xEMEP": {
        "center": [
            8.451439106121498,
            53.22866653708705
        ],
        "projection": "WebMercator",
        "zoom": 3.6,
        "max_zoom": 12,
        "radius": 2.5,
        "country_opacity": 0.5,
        "marker_symbol": "square"
    }
}